<template>
  <main-layout>
    <template #header>
      <main-header :title="'임대업체 관리' | translate" />
      <search-bar
        v-model="searchOptions.searchKeyword"
        :placeholder="'업체명/업체코드/사업자번호/대표자명' | translate"
        style="width: 450px;"
      />
    </template>

    <template #toolbar>
      <main-toolbar>
<!--        <search-single-select-box
          v-model="searchOptions.approvedYn"
          :items="approvedYnOptions"
          :label="'승인여부' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useYn"
          :items="cmsUseYnOptions"
          :label="'사용여부' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoUsage"
          :items="cmsUseYnOptions"
          :label="'월별사용량' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoSales"
          :items="cmsUseYnOptions"
          :label="'매출자동' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoCms"
          :items="cmsUseYnOptions"
          :label="'CMS 자동' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.useAutoTax"
          :items="taxYnOptions"
          :label="'세금계산서 자동' | translate"
          style="max-width: 160px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.cmsUseYn"
          :items="cmsUseYnOptions"
          :label="'CMS사용' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-single-select-box
          v-model="searchOptions.taxYn"
          :items="taxYnOptions"
          :label="'세금계산서' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
        <search-multi-select-box
          v-model="searchOptions.rentalcompanyGroups"
          :items="rentalCompanyGroupOptions"
          :label="'임대업체 그룹' | translate"
          style="max-width: 200px;"
          @update:selected="onFilterChanged"
        />-->
        <search-date-range-picker
          :start-date="searchOptions.startDate"
          :end-date="searchOptions.endDate"
          :label-for-end="'조회 종료일' | translate"
          :label-for-start="'조회 시작일' | translate"
          :clear-btn="false"
          style="max-width: 320px;"
          @update:date="updateDate"
        />
        <search-single-select-box
          v-model="searchOptions.actualYn"
          class="ml-2"
          :items="taxYnOptions"
          :label="'실사용자' | translate"
          style="max-width: 125px;"
          @update:selected="onFilterChanged"
        />
      </main-toolbar>
    </template>

    <template #body>
      <main-body>
        <base-table :headers="headers" :is-loading="isLoading" :items="convertItems" :items-total-count="itemsTotalCount"
                    :infinity-scroll="infinityScroll"
                    :sort-option="sortOption"
                    :page-number="searchOptions.pageNumber"
                    :page-length="pageLength"
                    :item-numbering="true"
                    @on-page-change="e => onLoad(e)"
                    @on-sort-change="onSortChange"
        >
          <template #item.fileCount="{ item }">
            <span v-if="item.fileCount <= 0"> - </span>
            <span v-else>
              <migration-data-modal
                :model="newRentalCompany(item)"
              />
            </span>
          </template>
        </base-table>
      </main-body>
    </template>
  </main-layout>
</template>

<script>
import MainLayout from "@/components/common/layout/MainLayout";
import MainBody from "@/components/common/layout/MainBody";
import MainToolbar from "@/components/common/layout/MainToolbar";
import MainHeader from "@/components/common/layout/MainHeader";
import {PATH} from "@/constants";
import {RentalCompany} from "@/model/rental-company";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
import SearchSingleSelectBox from "@/components/input/SearchSingleSelectBox";
import SearchBar from "@/components/input/new/SearchBar";
import MigrationDataModal from "./modal/MigrationDataModal";
import BaseTable from "../../components/common/newBase/InfinityScrollTable.vue";
import Headers from "../../components/common/newBase/Headers.vue";
import SearchMultiSelectBox from "@/components/input/SearchMultiSelectBox.vue";
import {DateTime} from "luxon";
import AdminDatePicker from "@/components/input/AdminDatePicker";
import SearchDateRangePicker from "@/components/input/new/SearchDateRangePicker";

export default {
  name: "MembershipList",
  components: {
    // SearchMultiSelectBox,
    BaseTable,
    MainToolbar,
    MainHeader,
    MainBody,
    MainLayout,
    MigrationDataModal,
    SearchBar,
    SearchDateRangePicker,
    // AdminDatePicker
    SearchSingleSelectBox,
  },
  extends: Headers,
  mixins: [TotalCodeOptions],
  data() {
    return {
      headers: [],
      searchOptions: {
        useYn: null,
        useAutoUsage: null,
        useAutoSales: null,
        useAutoCms: null,
        useAutoTax: null,
        cmsUseYn: null,
        startDate: null,
        endDate: null,
        searchKeyword: null,
        gpCdList: null,
        countryCodeList: null,
        approvedYn: null,
        taxYn: null,
        actualYn: 'Y',
        rentalcompanyGroups: [],
        pageNumber: 1,
        pageSize: 30,
      },
      sortOption: {
        sortBy: ['rentalcompanyId'],
        sortDesc: ['true'],
      },
      infinityScroll: true,
      items: [],
      itemsTotalCount: undefined,
      isLoading: false,

      rentalCompanyGroupOptions: [],
    }
  },

  computed: {
    pageLength() {
      if (!this.itemsTotalCount) return 1
      return Math.ceil(this.itemsTotalCount / this.searchOptions.pageSize)
    },

    /**
     * 목록 데이터에서 groupNamesText 를 나누어 groupNames 에 할당하고 반환합니다.
     * @param items
     * @returns {*}
     */
    convertItems() {
      return this.items.map(e => {
        return {
          ...e,
          groupNames: e.groupNamesText ? e.groupNamesText.split(',') : []
        }
      })
    },
  },

  watch: {
    'searchOptions.searchKeyword': {
      handler(newValue, oldValue) {
        this.onLoad(1)
      }
    },
  },


  beforeMount() {
    this.loadTaxYnOptions();
    this.headers = this.membershipStatsHeaders
    this.initPage()
  },

  methods: {
    initPage() {
      this.searchOptions.startDate = this.$now().startOf('month').toISO()
      this.searchOptions.endDate = this.$now().endOf('day').toISO()
      this.searchOptions.pageNumber = 1;
      this.itemsTotalCount = undefined
      this.items = []
      this.loadData();
    },

    async loadData() {
      if (this.isLoading) return
      try {
        this.isLoading = true
        const res = await this.$request(PATH.MEMBERSHIP.STATS)
          .setObject(
            {...this.searchOptions, ...this.sortOption}
          )
          .catch()
          .enqueue()

        this.itemsTotalCount = res.dataTotalCount
        this.items.push(...res.data)
        this.isLoading = false
      } catch (e) {
        console.log('Error: => ', e)
      }
    },

    onSortChange(option) {
      Object.keys(option).forEach(e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },

    updateDate(e) {
      this.searchOptions.startDate = e.startDate
      this.searchOptions.endDate = e.endDate
      this.onFilterChanged()
    },

    onFilterChanged() {
      this.onLoad(1)
    },

    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber
      if (!this.infinityScroll || pageNumber === 1)
        this.items.splice(0, this.items.length)
      this.loadData()
    },

    // 기존 모델로 반환
    newRentalCompany(e) {
      return new RentalCompany(e)
    },

    onClickItem(item) {

    },

    async onApproveRentalCompany(item) {
      this.$confirm(`확인을 누르면 [${item.rentalcompanyName}]에게 승인메일이 발송 됩니다.`).then(async () => {
        try {
          const res = await this.$request(PATH.MEMBERSHIP.APPROVE)
            .setObject({rentalcompanyId: item.rentalcompanyId})
            .catch()
            .enqueue()
          this.items.find(e => e.rentalcompanyId === item.rentalcompanyId).approvedYn = 'Y'
        } catch (e) {
          alert('에러발생')
          this.initPage()
        }
      })
    },

    async onUpdateRentalCompanyConfig(type, item) {
      this.$confirm(`확인을 누르면 [${item.rentalcompanyName}]의 설정이 변경 됩니다.`).then(async () => {
        try {
          const res = await this.$request(PATH.MEMBERSHIP.UPDATE_AUTO_STATUS, item.rentalcompanyId, type)
            .catch()
            .enqueue()
          this.items.find(e => e.rentalcompanyId === item.rentalcompanyId)[type] = res
        } catch (e) {
          alert('에러발생')
          this.initPage()
        }
      })
    },

    onRentalcompanyActualClick(item) {
      item.actualYn = item.actualYn === 'Y' ? 'N' : 'Y'
      this.onUpdateRentalCompanyInfo(item)
    },

    async onUpdateRentalCompanyInfo(item) {
      try {
        await this.$request(PATH.MEMBERSHIP.UPDATE_INFO)
          .setObject(item)
          .catch()
          .enqueue()
        const updateItem = this.items.find(e => e.rentalcompanyId === item.rentalcompanyId)
        Object.keys(item).forEach(e => updateItem[e] = item[e])
      } catch (e) {
        alert('에러발생')
        this.initPage()
      }
    },

    /**
     * 임대업체 그룹목록을 타이틀 문자열로 표시합니다.
     * @param groups
     * @returns {*|string}
     */
    rentalCompanyGroupsToTitle(groups) {
      if (!groups) return '-'

      return groups.join(', ')
    },

  },
}
</script>

<style scoped>
.vue-data-table >>> .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.6rem;
  height: 20px;
}

>>> .item--cell {
  height: 25px;
}

.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

}

.address-column {
  padding: 8px;
  height: 100%;
  width: 300px;
}

.rentalcompanyName-column {
  width: 150px;
}

.userFullname-column {
  width: 80px;
}

.ceoFullname-column {
  width: 80px;
}

>>> .v-input {
  font-size: 1rem !important;
}
</style>
